import { tWithKeyAttr as t } from "../../../i18nHelper";
import i18n from "../../../i18n";
import styles from "./hotlineQuestionnairePopup.module.css";

/**
 * Shown once per session, when the patient signs in and the returning-caller questionnaire is
 * open for them.
 *
 * It does not carry the questionnaire itself — it points at the tab. A modal that opened straight
 * into a depression and anxiety measure the moment somebody logged in would be ambushing them;
 * the tab is where they can see what it is and choose when.
 *
 * Dismissable on purpose, and dismissal is not recorded anywhere: the card stays in the tab, the
 * SMS still goes out on a real contact, and the therapist still sees the banner. Nothing depends
 * on this popup being acted on.
 */
interface IHotlineQuestionnairePopupProps {
  name: string;
  onClose: () => void;
  onGoToQuestionnaires: () => void;
}

function HotlineQuestionnairePopup({
  name,
  onClose,
  onGoToQuestionnaires,
}: IHotlineQuestionnairePopupProps) {
  return (
    <div dir={i18n.dir()} className={styles.popup}>
      <h3 className={styles.title}>{t("HOTLINE_QUESTIONNAIRE_POPUP_TITLE")}</h3>
      <p className={styles.name}>{name}</p>
      <p className={styles.text}>{t("HOTLINE_QUESTIONNAIRE_POPUP_TEXT")}</p>

      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={onGoToQuestionnaires}>
          {t("HOTLINE_QUESTIONNAIRE_POPUP_GO")}
        </button>
        <button type="button" className={styles.secondary} onClick={onClose}>
          {t("HOTLINE_QUESTIONNAIRE_POPUP_LATER")}
        </button>
      </div>
    </div>
  );
}

export default HotlineQuestionnairePopup;
